export default "__VITE_ASSET__DReC1UHt__"